import { memo } from 'react';
import { Transition } from '@headlessui/react';
import { useAiSearchContext } from '../AiSearchContext';
import { formatDateTimeWithTimezone } from '@/libs/core';
import Icon from '@/components/atoms/Icon';

function AiSearchRecentPanel() {
  const { isRecentSearchesVisible, savedSearches, closeRecentSearches, handleSearchSelect, handleDeleteClick } =
    useAiSearchContext();
  return (
    <Transition
      appear
      show={isRecentSearchesVisible}
      className="absolute top-full z-50 mt-2 w-full"
      enter="duration-200 ease-out"
      enterFrom="opacity-0 scale-95"
      enterTo="opacity-100 scale-100"
      leave="duration-150 ease-in"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
    >
      <div className="max-h-64 overflow-y-auto rounded-lg border bg-white py-3 shadow">
        <div className="mb-1 px-4 text-xs font-medium text-black/40">Recent Searches</div>
        {savedSearches.length > 0 ? (
          <div data-testid="scrollable-container">
            {savedSearches.map(savedSearch => {
              const formattedCreatedBy = savedSearch.created_by
                ? `${savedSearch.created_by.first_name} ${savedSearch.created_by.last_name}`
                : 'Anonymous';

              const formattedCreatedAt = formatDateTimeWithTimezone(savedSearch.created_at as string);

              return (
                <div key={savedSearch.id} className="group mx-1 flex items-center gap-2 rounded-md hover:bg-slate-50">
                  <button
                    type="button"
                    className="flex flex-1 items-center justify-between py-2 pl-3 text-left text-xs"
                    onClick={() => {
                      handleSearchSelect(savedSearch.id);
                      closeRecentSearches();
                    }}
                    data-testid={`search-item-${savedSearch.id}`}
                  >
                    <div>
                      <div className="mb-1 font-medium text-black">{savedSearch.title}</div>
                      <div className="text-[10px] text-slate-500">
                        By {formattedCreatedBy}
                        <span
                          aria-hidden
                          className="mx-1.5 mb-[2px] inline-block size-1 rounded-full bg-slate-500 align-middle"
                        />
                        {formattedCreatedAt}
                      </div>
                    </div>
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDeleteClick(savedSearch)}
                    className="invisible py-1 pr-3 text-xs text-slate-500 hover:text-slate-700 group-hover:visible"
                    data-testid={`delete-search-${savedSearch.id}`}
                  >
                    <Icon name="IconX" size={16} />
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="py-4 text-center text-sm text-slate-500">No recent searches</div>
        )}
      </div>
    </Transition>
  );
}

export default memo(AiSearchRecentPanel);
